import React, { Component } from "react";
import SimpleHeader from "../../../base/features/blocks/SimpleHeader";
import ManagementProducts from "../products/ManagementProducts";

class ShopActivation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
    };
  }

  render() {
    return (
      <div className="container-fluid px-0">
        <SimpleHeader path="/new-shop" text={"افزودن محصول"} />
        <body style={{ marginTop: "80px" }}>
          <ManagementProducts activation={true} />
        </body>
      </div>
    );
  }
}

export default ShopActivation;
